import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { FormControlLabel, MenuItem, Select, Typography } from '@mui/material';
import { DatasetCreationEnum, DatasetStatus } from '~/api/types';
import { useGetDatasetEnumsQuery } from '~/api/v2/hooks';
import { InfoFormLabel } from '~/components';
import { ChangeStatusModal } from '..';

const StatusField = () => {
  const datasetId = +useParams().id!;
  const { data, isFetching } = useGetDatasetEnumsQuery({ enumKey: DatasetCreationEnum.STATUS });
  const { control } = useFormContext();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedStatus, setSelectedStatus] = useState<DatasetStatus | null>(null);

  return (
    <>
      <FormControlLabel
        label={
          <InfoFormLabel
            label="DATASET STATUS"
            tooltipText={
              datasetId ? (
                <Typography>
                  Set the dataset to <b>Locked – Searchable</b> to allow access requests. Use <b>Publish</b> from the
                  catalog table to make approved data available in Atlan.
                  <br /> <br />
                  Use <b>Locked – Restricted</b> for designated‑access or inactive datasets; this prevents edits and
                  access requests. To make changes, reset the status to <b>In Progress</b>.
                </Typography>
              ) : null
            }
          />
        }
        required
        control={
          <Controller
            name="status"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Select
                {...field}
                onChange={(e) => e.preventDefault()}
                disabled={isFetching || !datasetId}
                renderValue={(selected) => selected ?? ''}
              >
                {data?.map(({ value }) => (
                  <MenuItem
                    key={value}
                    value={value}
                    onClick={() => {
                      if (value === field.value) return;

                      setSelectedStatus(value as DatasetStatus);
                      if (
                        [DatasetStatus.LOCKED_SEARCHABLE, DatasetStatus.LOCKED_RESTRICTED].includes(
                          value as DatasetStatus,
                        )
                      )
                        setOpenModal(true);
                      else field.onChange(value);
                    }}
                  >
                    {value}
                  </MenuItem>
                ))}
              </Select>
            )}
          />
        }
      />
      <ChangeStatusModal open={openModal} onClose={() => setOpenModal(false)} selectedStatus={selectedStatus} />
    </>
  );
};

export default StatusField;
